export default{sources:{avif:"__VITE_ASSET__oe0p2VAL__ 16w",webp:"__VITE_ASSET__eAuDyUft__ 16w"},img:{src:"__VITE_ASSET__COJRBZRs__",w:16,h:16}};